import { useTranslation } from 'react-i18next';
import { ArrowLeft, ArrowRight, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface WizardNavigationProps {
  canGoBack: boolean;
  canGoNext: boolean;
  isLastStep: boolean;
  isSubmitting: boolean;
  onBack: () => void;
  onNext: () => void;
  onSubmit: () => void;
}

export function WizardNavigation({
  canGoBack,
  canGoNext,
  isLastStep,
  isSubmitting,
  onBack,
  onNext,
  onSubmit,
}: WizardNavigationProps) {
  const { t } = useTranslation('staff');

  return (
    <div
      className="sticky bottom-0 bg-white border-t px-4 py-4"
      style={{ paddingBottom: 'calc(1rem + env(safe-area-inset-bottom))' }}
    >
      <div className="flex gap-3">
        {canGoBack && (
          <Button
            variant="outline"
            onClick={onBack}
            disabled={isSubmitting}
            className="flex-1 min-h-[48px] tap-highlight-transparent"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            {t('availability.wizard.navigation.back', 'Back')}
          </Button>
        )}

        {isLastStep ? (
          <Button
            onClick={onSubmit}
            disabled={!canGoNext || isSubmitting}
            className={cn(
              'min-h-[48px] tap-highlight-transparent',
              canGoBack ? 'flex-1' : 'w-full'
            )}
          >
            {isSubmitting ? (
              <>
                <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                {t('availability.wizard.navigation.creating', 'Creating...')}
              </>
            ) : (
              t('availability.wizard.navigation.create', 'Create Availability')
            )}
          </Button>
        ) : (
          <Button
            onClick={onNext}
            disabled={!canGoNext || isSubmitting}
            className={cn(
              'min-h-[48px] tap-highlight-transparent',
              canGoBack ? 'flex-1' : 'w-full'
            )}
          >
            {t('availability.wizard.navigation.continue', 'Continue')}
            <ArrowRight className="w-4 h-4 ml-2" />
          </Button>
        )}
      </div>
    </div>
  );
}
